const getElement = (bookshelfOption, isSelected) => `
  <li
    class="action ${isSelected ? 'selected' : ''}"
  >
    <a
      title="${bookshelfOption.text}"
    >
      ${bookshelfOption.text}
      <span class="dui-icon">
        <svg viewBox="0 0 16 16">
          <g
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g
              id="icon-fill"
              transform="translate(-272.000000, -16.000000)"
              fill="#000000"
            >
              <g transform="translate(272.000000, 16.000000)">
                <path d="M15.3640215,0.768949421 C14.6741437,0.311696071 13.7038708,0.452637692 13.2002177,1.07665403 L5.3692582,10.7951705 L2.76422885,7.80742334 C2.23306527,7.20062125 1.25961807,7.09733579 0.588785974,7.57610694 C-0.0831042125,8.0548781 -0.196320354,8.93818398 0.333785132,9.54283429 L5.46871911,15.4333333 L15.7026118,2.72706965 C16.206265,2.10090153 16.0549574,1.22512688 15.3640215,0.768949421" />
              </g>
            </g>
          </g>
        </svg>
      </span>
    </a>
  </li>
`;

export default function bookshelfElement(bookshelfOption, currentBookshelf, clickEvent) {
  const wrapper = document.createElement('div');
  const isSelected = currentBookshelf === bookshelfOption.value;
  wrapper.innerHTML = getElement(bookshelfOption, isSelected);
  wrapper.querySelector('a').addEventListener('click', clickEvent);
  return wrapper.children[0];
};
